import { render, staticRenderFns } from "./CreateAccountInputs.vue?vue&type=template&id=2a56a297&scoped=true"
import script from "./CreateAccountInputs.vue?vue&type=script&lang=js"
export * from "./CreateAccountInputs.vue?vue&type=script&lang=js"
import style0 from "./CreateAccountInputs.vue?vue&type=style&index=0&id=2a56a297&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a56a297",
  null
  
)

export default component.exports